import {gsap} from "gsap";
import Swiper from "swiper";
import {Navigation} from "swiper/modules";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {SplitText} from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);
window.addEventListener('load', () => {
    const isMobileFirstLoad = window.innerWidth < 768;

    if(!isMobileFirstLoad) {

        const tlBlockInstallation = gsap.timeline({
            scrollTrigger: {
                trigger: '.mksun-block-installation'
            }
        });

        const titleBlockInstallation = new SplitText(
            '.mksun-block-installation .timeline-text-reveal:not(.timeline-text-reveal--lines)',
            {
                type: 'words'
            }
        );

        tlBlockInstallation.from(
            titleBlockInstallation.words,
            {
                y: '100%',
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            }
        );

        tlBlockInstallation.from(
            '.mksun-block-installation__cards-ctn__card',
            {
                y: '6rem',
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            },
            '<'
        );
    }

    const sliderBlockInstallationYoutube = new Swiper(
        '.mksun-block-installation__cards-ctn__card__slider-ytb',
        {
            slidesPerView: 'auto',
            grabCursor: true,
            spaceBetween: 20,
            modules: [Navigation],
            navigation: {
                nextEl: '.mksun-block-installation__cards-ctn__card__slider-ytb__controls__next',
                prevEl: '.mksun-block-installation__cards-ctn__card__slider-ytb__controls__prev'
            }
        }
    );});

const sliderBlockInstallationSteps = new Swiper(
    '.mksun-block-installation__cards-ctn__card__slider-steps',
    {
        slidesPerView: 'auto',
        grabCursor: true,
        spaceBetween: 20,
        modules: [Navigation],
        navigation: {
            nextEl: '.mksun-block-installation__cards-ctn__card__slider-steps__controls__next',
            prevEl: '.mksun-block-installation__cards-ctn__card__slider-steps__controls__prev'
        }
    }
);